<template>
  <a-form ref='form' :model='search' class="m-b-25" :initialValues="search" :onFinish='pageSearchChange'
    layout='inline'>
    <a-form-item>
      <a-radio-group v-model:value="search.type" button-style="solid" @change="onChangeRadio">
        <a-radio-button :value="1">门店</a-radio-button>
        <a-radio-button :value="2">商品</a-radio-button>
        <a-radio-button :value="3">经销商</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item>
      <a-radio-group v-model:value="search.day_type" button-style="solid" @change="onChangeDay">
        <a-radio-button :value="1">最近7天</a-radio-button>
        <a-radio-button :value="2">最近30天</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="" name=''>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <echartCake :echartsData='echartData' v-if='!listLoading'></echartCake>
  <p class="text-ac m-b-25">{{search.type == 2 ? '商品' : (search.type == 3 ? '经销商' : '门店')}}Top30排名GMV：{{data.gmv}}</p>
  <a-table class='tableFixBox' :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columns'
    :data-source='data.list' :scroll="{ x: 'max-content'}">
    <template #nameTitle>
      <span>{{search.type == 2 ? '商品名称' : (search.type == 3 ? '经销商名称' : '门店名称')}}</span>
    </template>
    <template #oneTitle>
      <span>{{search.type == 2 ? '门店销量TOP1' : '商品销量TOP1'}}</span>
    </template>
    <template #twoTitle>
      <span>{{search.type == 2 ? '门店销量TOP2' : '商品销量TOP2'}}</span>
    </template>
    <template #threeTitle>
      <span>{{search.type == 2 ? '门店销量TOP3' : '商品销量TOP3'}}</span>
    </template>
    <template v-slot:top_one="{ record }">
      <p>{{record.top_one.name || '-'}}</p>
    </template>
    <template v-slot:top_two="{ record }">
      <p>{{record.top_two.name || '-'}}</p>
    </template>
    <template v-slot:top_three="{ record }">
      <p>{{record.top_three.name || '-'}}</p>
    </template>
    <template v-slot:action="{ record }">
      <a v-has:cloudOrderStatisticsDetail="()=> {$router.push('/order/order_statistics/statistics_more?id='+record.id+'&type='+search.type)}" href="javascript:;">查看详情</a>
    </template>
  </a-table>
  <!-- <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" /> -->
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { getOrderStatistics } from "@/api/order";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  let defSearch = {
    type: 1,
    day_type: 1,
    start_time: '',
    end_time: '',
    key_type: '',
  };
  export default {
    components: {},
    name: 'orderList',
    setup(props, { emit }) {
      // 列表数据和列头配置
      let data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        echartData:{},
        time: [],
        listLoading: false,
        columns: [
          {
            dataIndex: "name",
            key: "name",
            slots: { title: 'nameTitle' },
          },
          {
            title: "下单人数",
            dataIndex: "order_count",
            key: "order_count",
          },
          {
            title: "支付订单数",
            dataIndex: "order_pay_count",
            key: "order_pay_count",
          },
          {
            title: "总金额",
            dataIndex: "order_price_count",
            key: "order_price_count",
          },
          {
            dataIndex: "top_one",
            key: "top_one",
            slots: { customRender: "top_one",title: 'oneTitle' },
          },
          {
            dataIndex: "top_two",
            key: "top_two",
            slots: { customRender: "top_two",title: 'twoTitle' },
          },
          {
            dataIndex: "top_three",
            key: "top_three",
            slots: { customRender: "top_three",title: 'threeTitle' },
          },
          {
            title: "操作",
            key: "action",
            fixed: 'right',
            slots: { customRender: "action" },
          },
        ]
      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const onChangeRadio = (e) => {
        search.value.store = '';
        search.value.product_name = '';
        search.value.dealer = '';
        initData(search.value);
      }
      const onChangeDay = () => {
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
        initData(search.value);
      }
      const onChange = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
        search.value.day_type = 0
      }
      // 页面筛选项搜索
      const pageSearchChange = () => {
        initData(search.value);
      };
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getOrderStatistics(values).then(res => res.data);
          if (iscode(res)) {
            data.value = res.data;
            state.echartData = res.data
          } else {
            message.error(res.msg);
          }
          state.listLoading = false;
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        onChangeDay,
        onChange,
        onChangeRadio,
        pageSearchChange
      };
    },
  };
</script>
<style lang="less" >
  .ant-table td {
    white-space: nowrap;
  }
</style>